module.exports = __webpack_public_path__ + "img/29.ef8e2ef8.jpg";